import { useEffect, useState, useRef, MutableRefObject } from 'react';

export function useCartButtonIntersectionObserver(
  ref: MutableRefObject<HTMLDivElement | null>,
  options: IntersectionObserverInit = {}
) {
  const [element, setElement] = useState<HTMLDivElement | null>(null);
  const [isVisible, setIsVisible] = useState(false);
  const observer = useRef<null | IntersectionObserver>(null);

  const cleanOb = () => {
    if (observer.current) {
      observer.current.disconnect();
    }
  };

  useEffect(() => {
    setElement(ref.current);
  }, [ref]);

  useEffect(() => {
    if (!element) return;
    cleanOb();

    const ob = (observer.current = new IntersectionObserver(
      ([entry]) => {
        const isElementIntersecting = entry.isIntersecting;
        if (isElementIntersecting) {
          setIsVisible(isElementIntersecting);
        } else {
          if (entry.boundingClientRect.top >= 0) {
            setIsVisible(true);
          } else {
            setIsVisible(isElementIntersecting);
          }
        }
      },
      { ...options }
    ));
    ob.observe(element);
    return () => {
      cleanOb();
    };
  }, [element, options, isVisible]);

  return isVisible;
}
